import { GeneralLocaleTypes } from '../locales.types'

const generalLocaleNo: GeneralLocaleTypes = {
  minute: 'minutt',
  minutes: 'minutt',
  min: 'min',

  showingOf: 'Viser {{ visibleRows }} av {{ totalDataRows }}',
  showLess: 'Vis mindre',
  showMore: 'Vis meir',

  invalid: 'Ugyldig',

  fileSelect: 'Velg en fil',

  userNotFound: 'Bruker ikke funnet',
  noMoreResults: 'Ingen flere resultater',
  loadMoreResults: 'Last inn flere resultater',
  yes: 'Ja',
  no: 'Nei',
  teacher: 'Lærer',

  assignment_one: 'Oppgave',
  assignment_other: 'Oppgaver',

  entry_one: 'Entry',
  entry_other: 'Entries',

  group_one: 'Gruppe',
  group_other: 'Grupper',

  somethingAndAnotherThing: '{{ something }} og {{ anotherThing }}',

  feideFetchStatus: {
    title: 'Feide-synkronisering...',
    fetching: 'Oppdaterer database med Feide-informasjon',
    error: 'Det oppstod en feil under forsøk på å hente informasjon fra feide',
    success: 'Studentoppdatering fra Feide var vellykket'
  },

  filters: {
    text: {
      filterBy: 'Filtrer etter:',
      filterResults: 'Filtreringsresultat',
      clearFilters: 'Fjern filtre',
      selectItem: 'Vell eit {{ topic }}'
    },
    status: {
      title: 'Status',
      item: {
        allAssignments: 'Alle oppgåver',
        progress: 'Aktiv',
        upcoming: 'Planlagd',
        finished: 'Inaktiv'
      }
    },
    topics: {
      title: 'Tema'
    },
    subjects: {
      title: 'Emne',
      item: {
        multiplication: 'Multiplikasjon',
        probability: 'Sannsyn',
        division: 'Divisjon',
        fraction: 'Brøk',
        additionAndSubtraction: 'Addisjon og subtraksjon',
        negativeNumbers: 'Negative tal'
      }
    },
    assigned: {
      title: 'Tildelt',
      item: {
        students: 'Elever',
        groups: 'grupper'
      }
    },
    planets: {
      title: 'Planetar'
    },
    skills: {
      title: 'Ferdigheiter'
    },
    groups: {
      title: 'Alle Grupper'
    }
  },
  imageAlt: {
    login: {
      gameCharacters: 'Spelkarakterar'
    }
  },
  status: {
    error: {
      notFound: {
        title: 'Oops! <br/> Vi finner ikke siden du leter etter.',
        description:
          'Dette kan skyldes at siden ikke finnes lenger, eller at innholdet har blitt flyttet. <customLink>Gå til forsiden</customLink> eller velg en annen side fra hovedmenyen.'
      },
      somethingWentWrong: 'Noko gjekk gale',
      cannotUndoThisAction:
        'Du kan <strong>ikke</strong> angre denne handlingen.'
    },
    active: 'Aktiv',
    inactive: 'Inactive',
    payment: {
      paid: 'Betalt',
      notPaid: 'Ikke betalt',
      sent: 'Sendt',
      notSent: 'Ikke sendt'
    }
  },
  state: {
    nrOfModesSelected: '{{ count }} Modus valgt',
    nrOfModesSelected_plural: '{{ count }} moduser valgt',
    nrOfModesSelected_0: 'Ingen moduser valgt',
    selected: 'Valt',
    notSelected: 'Ikke valgt',
    selectedNumber: '{{ selectedNumber }} valt',
    removed: 'Fjerna',
    deleted: 'Sletta',
    modified: 'Modifisert',
    started: 'Påbyrja',
    ended: 'Avslutta',
    comingSoon: 'Kommer snart',
    quitEditing: 'Forlat siden?',
    searchResultsFor: 'Søkeresultater for {{ value }}',
    loading: 'Laster...',
    studentAdded: 'Elev lagt til',
    ok: 'Ok'
  },
  selectAll: 'Vel alle',
  actions: {
    viewReport: 'Se rapport',
    add: 'Legg til',
    addNewTopic: 'Legg til et oppdrag',
    addAndClose: 'Legg til og lukk',
    addAndContinue: 'Legg til og fortsett',
    edit: 'Rediger',
    view: 'Opne',
    delete: 'Slett',
    remove: 'Fjern',
    next: 'Neste',
    back: 'Attende',
    createGroup: 'Lag ny gruppe',
    saveGroup: 'Lag ny gruppe',
    save: 'Lagre {{ addOn }}',
    saveChanges: 'Lagre endringar',
    saveCustomer: 'Redd kunde',
    update: 'Oppdater {{ addOn }}',
    select: 'Vel',
    confirm: 'Bekreft',
    cancel: 'Avbryt',
    report: 'Sjå rapport ',
    editParentsName: 'Rediger namn på føresette',
    moveToGroup: 'Flytt til ei gruppe',
    revoke: 'Fjern',
    moreOptions: 'Fleire val',
    close: 'Lukk',
    goToArticle: 'Gå til artikkelen',
    keepEditing: 'Rediger videre',
    quit: 'Ja, forlat',
    show: 'Vis',
    hide: 'Skjul',
    unHide: 'Gjenopprett'
  },
  user: {
    accountSettings: 'Kontoinnstillingar'
  },
  errors: {
    invalidDate: 'Ugyldig dato',
    invalidTime: 'Ugyldig tid',
    shouldNotBeEmpty: 'Skal ikke være tom',
    shouldNotBeEmptyAddon: '{{ key }} skal ikke være tom',
    unexpectedError: 'Uventet feil',
    notSaved: 'Dine endringer vil <strong>ikke</strong> bli lagret.'
  },
  validation: {
    required: 'Dette er et obligatorisk felt'
  },
  dealTypes: {
    municipality: 'Kommune',
    school: 'Skole'
  }
}

export default generalLocaleNo
